import React, { useState, useRef, useEffect } from "react";
import styles from "../styles/AIChat.module.scss";
import izziLogo from "../assets/images/izziTelecomLogo.png";
import userProfile from "../assets/images/social-media_16327810.png";
import settings from "../assets/images/setting_2040504.png";
import genericLogo from "../assets/images/generic_logo2.png";

type navbarProps = {
	checkWhenLogged: (logged: boolean) => void;
	userLogged: boolean;
};

function Navbar({ checkWhenLogged, userLogged }: navbarProps) {
	const [isOpen, setIsOpen] = useState(false);
	const menuRef: any = useRef(null);
	const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
	const organizationName: string = userData.organization_name;
	const userEmail: string = userData.email;

	const handleLogout = () => {
		// Add logout logic here
		console.log("Logging out...");
		checkWhenLogged(false);
		setIsOpen(false);
		sessionStorage.removeItem("userData");
	};

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			// Check if menuRef.current is not null and does not contain the clicked element
			if (menuRef.current instanceof HTMLElement && !menuRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);
	return (
		<>
			<header className={`sticky-top px-4 py-2 d-flex align-items-center justify-content-between z-3  ${styles["header-blur"]}`}>
				<div className="d-flex align-items-center">
					<img src={genericLogo} alt="Logo" height="64" />
					<div className="vr mx-3 text-secondary opacity-25" style={{ height: "48px" }}></div>
					<div>
						<h2 className="m-0 fs-6 fw-bold text-uppercase tracking-wider">Aseguramiento de ingresos por IA</h2>
						<p className={`m-0 fw-medium ${styles["text-primary-brand"]}`} style={{ fontSize: "10px" }}>
							Desarrollado por NEWTOMS AI
						</p>
					</div>
				</div>

				<div className="d-flex align-items-center gap-3">
					{/* <button className="btn btn-link text-secondary p-1" style={{ width: "40px", height: "40px", flexShrink: 0 }}>
						<img className="material-symbols-outlined img-fluid" src={settings} alt="" />
					</button> */}
					<span className="text-dark">{userEmail}</span>
					<button
						onClick={() => setIsOpen(!isOpen)}
						className="btn btn-link text-secondary p-1"
						style={{ width: "40px", height: "40px", flexShrink: 0 }}>
						<img className="material-symbols-outlined img-fluid" src={userProfile} alt="" />
					</button>
				</div>
			</header>
			{isOpen && (
				<ul
					className="dropdown-menu show"
					ref={menuRef}
					style={{
						position: "absolute",
						right: "5px",
						left: "auto",
						top: "70px",
						display: "block",
						boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
					}}>
					<li>
						<h6 className="dropdown-header">User Account</h6>
					</li>
					<li>
						<button className="dropdown-item d-flex align-items-center" type="button">
							Settings
						</button>
					</li>
					<li>
						<hr className="dropdown-divider" />
					</li>
					<li>
						<button onClick={handleLogout} className="dropdown-item d-flex align-items-center text-danger" type="button">
							Logout
						</button>
					</li>
				</ul>
			)}
		</>
	);
}

export default Navbar;
